import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
`;

export const EmptyStateContainer = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const RowsList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
